/**
 * Aspetto chiaro o scuro.
 *
 * La preferenza vera sta sul profilo dell'operatore, così lo segue da una
 * postazione all'altra. Una copia resta nel browser per applicarla prima che
 * la pagina compaia (vedi lo script in `index.html`): senza, chi lavora in
 * scuro vedrebbe un lampo bianco a ogni caricamento.
 */

export type Aspetto = 'system' | 'light' | 'dark';

const CHIAVE = 'lr-aspetto';
const sistema = window.matchMedia('(prefers-color-scheme: dark)');

export function aspettoSalvato(): Aspetto {
  const valore = localStorage.getItem(CHIAVE);
  return valore === 'light' || valore === 'dark' || valore === 'system' ? valore : 'system';
}

export function applicaAspetto(aspetto: Aspetto): void {
  localStorage.setItem(CHIAVE, aspetto);
  const scuro = aspetto === 'dark' || (aspetto === 'system' && sistema.matches);
  document.documentElement.dataset.theme = scuro ? 'dark' : 'light';
}

/** Segue le impostazioni del computer mentre l'applicazione è aperta. */
export function seguiSistema(): () => void {
  const reagisci = () => {
    if (aspettoSalvato() === 'system') applicaAspetto('system');
  };
  sistema.addEventListener('change', reagisci);
  return () => sistema.removeEventListener('change', reagisci);
}
